// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".background-image[data-v-c3995eb4]{box-shadow:0 10px 30px rgba(29,140,242,.2)}.second-box[data-v-c3995eb4]{position:absolute;right:300px}.white-text[data-v-c3995eb4]{color:#fff}span[data-v-c3995eb4]{color:#02c3cc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
